import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Alert, AlertIcon } from '@chakra-ui/react'
import { paths } from '../../../../../../../../app/routes'

const EntityCount = ({ connector, entityCount }) => (
    <>
        <h3 className="subtitleNew">
            Business Entity ({entityCount})
            {entityCount > 0 ? (
                <Link className="float-right text-primary viewDetails" to={paths.viewSummary(connector.connectorId)}>
                    View Details
                </Link>
            ) : (
                <button className="float-right text-primary no-border disabledNew" title="Installation setup is incomplete" disabled>
                    View Details
                </button>
            )}
        </h3>
        <Box>
            {entityCount < 1 && !connector.isSetupCompleted ? (
                <Alert status="warning">
                    <AlertIcon />
                    <Box fontSize="13px">
                        You're almost there! A few more steps are needed, Please{' '}
                        <Link className="setupButtonDashboard" to={paths.setup(connector.connectorId, connector.instanceId)}>
                            click here
                        </Link>
                        {' '}to complete the setup
                    </Box>
                </Alert>
            ) : null}
        </Box>
    </>
)

export default EntityCount
